var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 0H1.66668C0.747461 0 0 0.747461 0 1.66668V13.3334C0 14.2525 0.747461 15 1.66668 15H18.3334C19.2525 15 20 14.2525 20 13.3333V1.66668C20 0.747461 19.2525 0 18.3333 0ZM1.66668 0.83332H18.3334C18.3948 0.83332 18.4489 0.855703 18.5065 0.86836C17.0636 2.18895 12.279 6.56598 10.6047 8.07453C10.4737 8.19254 10.2625 8.33332 10 8.33332C9.73758 8.33332 9.52641 8.19254 9.39496 8.07414C7.72078 6.56582 2.93598 2.18855 1.49328 0.868438C1.55102 0.855781 1.60523 0.83332 1.66668 0.83332ZM0.83332 13.3333V1.66668C0.83332 1.58504 0.85793 1.51098 0.879961 1.43637C1.98434 2.44715 5.32277 5.50121 7.48746 7.46969C5.3298 9.32309 1.99051 12.489 0.877344 13.5505C0.857695 13.4796 0.83332 13.4104 0.83332 13.3333ZM18.3333 14.1667H1.66668C1.60012 14.1667 1.54094 14.1435 1.47879 14.1286C2.62906 13.0321 5.98961 9.84793 8.10934 8.03453C8.35157 8.25442 8.59415 8.47392 8.83707 8.69305C9.18051 9.00312 9.5825 9.16668 10 9.16668C10.4175 9.16668 10.8195 9.00309 11.1625 8.69344C11.4056 8.47418 11.6483 8.25454 11.8907 8.03453C14.0105 9.84773 17.3706 13.0316 18.5212 14.1286C18.4591 14.1435 18.4 14.1667 18.3333 14.1667ZM19.1667 13.3333C19.1667 13.4103 19.1423 13.4796 19.1227 13.5505C18.0091 12.4885 14.6702 9.32289 12.5126 7.46973C14.6773 5.50125 18.0153 2.44746 19.12 1.43629C19.1421 1.5109 19.1667 1.585 19.1667 1.66664V13.3333Z",
    fill: "#FAF9F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopIcon);
export default __webpack_public_path__ + "static/media/envelop_icon.9666d8d71fa24e333c725a80edc9cb7b.svg";
export { ForwardRef as ReactComponent };